import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "@/api/client";

/**
 * TanStack Query owns ALL server state — no component fetches into useState.
 *
 * Defaults are tuned for an operational admin tool: data is shared and moves
 * often, so refetching on focus is right, but retrying a 4xx is not — the
 * client already retries once after a token refresh, and a 401/403/404 will
 * not become a 200 by asking again.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Long enough to stop a tab-switch storm, short enough that numbers on
      // screen are not stale in a way anyone would act on.
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: (failureCount, error) => {
        if (error instanceof ApiError) {
          // Network blips are worth one more go; a refused request is not.
          if (error.isNetworkError) return failureCount < 2;
          if (error.status >= 400 && error.status < 500) return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      // Never silently repeat a write.
      retry: false,
    },
  },
});
